export const GET_TATTLE_SURVEY_CONFIG_REQUESTED = 'brand/GET_TATTLE_SURVEY_CONFIG_REQUESTED';
export const GET_TATTLE_SURVEY_CONFIG_SUCCESS = 'brand/GET_TATTLE_SURVEY_CONFIG_SUCCESS';
export const GET_TATTLE_SURVEY_CONFIG_FAILURE = 'brand/GET_TATTLE_SURVEY_CONFIG_FAILURE';

export const UPDATE_TATTLE_SURVEY_CONFIG_REQUESTED = 'brand/UPDATE_TATTLE_SURVEY_CONFIG_REQUESTED';
export const UPDATE_TATTLE_SURVEY_CONFIG_SUCCESS = 'brand/UPDATE_TATTLE_SURVEY_CONFIG_SUCCESS';
export const UPDATE_TATTLE_SURVEY_CONFIG_FAILURE = 'brand/UPDATE_TATTLE_SURVEY_CONFIG_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  tattleSurveyList: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_TATTLE_SURVEY_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        tattleSurveyList: [],
      };
    }
    case GET_TATTLE_SURVEY_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        tattleSurveyList: action.result,
      };
    }
    case GET_TATTLE_SURVEY_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case UPDATE_TATTLE_SURVEY_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_TATTLE_SURVEY_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_TATTLE_SURVEY_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getTattleSurveyListConfig = (brandId) => {
  return {
    types: [GET_TATTLE_SURVEY_CONFIG_REQUESTED, GET_TATTLE_SURVEY_CONFIG_SUCCESS, GET_TATTLE_SURVEY_CONFIG_FAILURE],
    promise: client => client.get(`getTattleSurveyListConfig/${brandId}`)
  };
};

export const updateTattleSurveyListConfig = (brandId, data) => {
  return {
    types: [UPDATE_TATTLE_SURVEY_CONFIG_REQUESTED, UPDATE_TATTLE_SURVEY_CONFIG_SUCCESS, UPDATE_TATTLE_SURVEY_CONFIG_FAILURE],
    promise: client => client.post(`updateTattleSurveyListConfig/${brandId}`, { data })
  };
};
